import {

  DEFAULT_LEARNER_PERSIAN_FONT,

  LEARNER_UI_PERSIAN_STACK,

  isLearnerPersianFontId,

  LEARNER_PERSIAN_FONT_STORAGE_KEY,

  type LearnerPersianFontId

} from '../constants/learnerPersianFonts';

import { LESSON_FONT_MULTIPLIER_STORAGE_KEY } from '../components/learning/FontSizeContext';



const DATA_ATTR = 'data-learner-persian-font';



export function readStoredLearnerPersianFont(): LearnerPersianFontId {

  try {

    const raw = localStorage.getItem(LEARNER_PERSIAN_FONT_STORAGE_KEY);

    if (raw && isLearnerPersianFontId(raw)) return raw;

  } catch {

    /* ignore */

  }

  return DEFAULT_LEARNER_PERSIAN_FONT;

}



export function persistLearnerPersianFont(id: LearnerPersianFontId): void {

  try {

    localStorage.setItem(LEARNER_PERSIAN_FONT_STORAGE_KEY, id);

  } catch {

    /* ignore */

  }

}



/**

 * Persists lesson typeface id on `documentElement` and keeps `--font-persian` on the **UI stack**

 * (loaders, forms, exercises). Lesson bodies use the id via `lessonTypography` on `FormattedTextBlock`.

 */

export function applyLearnerPersianFont(id: LearnerPersianFontId): void {

  if (typeof document === 'undefined') return;

  const root = document.documentElement;

  root.setAttribute(DATA_ATTR, id);

  root.style.setProperty('--font-persian', LEARNER_UI_PERSIAN_STACK);

}



/** After login: sync lesson font id, UI `--font-persian`, and lesson text size from the account. */

export async function hydrateLearnerPersianFontFromServer(): Promise<void> {

  try {

    const { authService } = await import('../services/authService');

    if (!authService.isAuthenticated()) return;

    const prefs = await authService.getLearningPreferences();

    const raw = prefs.preferredPersianFontId?.trim().toLowerCase();

    if (raw && isLearnerPersianFontId(raw)) {

      persistLearnerPersianFont(raw);

    }

    applyLearnerPersianFont(readStoredLearnerPersianFont());



    const m = prefs.lessonTextFontMultiplier;

    if (typeof m === 'number' && Number.isFinite(m)) {

      const clamped = Math.max(0.35, Math.min(3, m));

      try {

        localStorage.setItem(LESSON_FONT_MULTIPLIER_STORAGE_KEY, String(clamped));

      } catch {

        /* ignore */

      }

      window.dispatchEvent(new CustomEvent('app:lessonTextMultiplierHydrated', { detail: { multiplier: clamped } }));

    }

  } catch {

    /* offline / unauthenticated */

  }

}

